const config = {
  basename: "/TransMex/Web",
  keyHash: "$2a$11$sb.WL/hCzS5VMb07QjxbyO",
  url: "https://ibo.transmex.com.mx/TransMex/Api",
  paths: {
    userImage: "Usuario/ImagenUsuario",
    employeeImage: "Empleados/ImagenEmpleado",
    inspectionGeneralImage: "Inspecciones/General/Imagen",
    inspectionPointCheckList: "PuntosInspeccionCheckList/Imagen",
    damageReview: "Revisiones/Dano/Imagen",
  },
};

export default config;
